import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { SpinnerCircular } from 'spinners-react';
import { cn } from '../../utils/cn';

const SUBMIT_CLASS =
    'inline-flex w-full items-center justify-center rounded-[14px] bg-custom-blue-primary px-4 py-3.5 text-center text-[0.9375rem] font-bold tracking-wide text-white transition hover:bg-custom-blue-300 disabled:pointer-events-none disabled:border-[#c9ced6] disabled:bg-[#d0d6df] disabled:text-white disabled:opacity-100 md:w-auto md:min-w-[12.5rem] md:rounded-xl';

type PrimarySubmitProps = {
    children: ReactNode;
    disabled?: boolean;
    loading?: boolean;
    className?: string;
} & Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'onClick'>;

export default function PrimarySubmit({
    children,
    disabled = false,
    loading = false,
    type = 'button',
    onClick,
    className,
}: PrimarySubmitProps) {
    return (
        <button
            type={type}
            disabled={disabled || loading}
            onClick={onClick}
            className={cn(SUBMIT_CLASS, className)}
        >
            {children}
            {loading ? (
                <SpinnerCircular
                    size={15}
                    thickness={200}
                    color='#0A64C8'
                    secondaryColor='silver'
                    className='ml-2'
                />
            ) : null}
        </button>
    );
}
